import { Route, RouteGroup } from '@billow/easy-route'
import { concat } from 'lodash'

export default RouteGroup({

  middleware: ['auth', 'password-set'],

  routes: concat(
    [
      Route('/connections', 'connection-index', () => import(`@/views/connections/Index`)),
      Route('/connection-requests', 'connection-requests-incoming', () => import(`@/views/connections/ConnectionRequestsPending`)),
      Route('/connection-requests/pending', 'connection-requests-pending', () => import(`@/views/connections/ConnectionRequests`)),
    ],

    RouteGroup({
      parent: Route('/connections', '', () => import('@/views/connections/NewCompany')),

      routes: [
        Route('create', 'new-company', () => import(`@/views/connections/Create`)),
        Route('new-company', 'create-company', () => import(`@/views/connections/CreateCompany`)),
        Route('connect', 'connect-with-company', () => import(`@/views/connections/ConnectWithCompany`)),
      ],
    }),

    RouteGroup({
      parent: Route('/connections/:company', '', () => import('@/views/connections/manager/Index')),

      routes: [
        Route('/', 'company-manager', () => import(`@/views/connections/manager/Overview`)),
        Route('projects', 'company-projects', () => import(`@/views/connections/manager/Projects`)),
        Route('assets', 'company-assets', () => import(`@/views/connections/manager/Assets`)),
        Route('permissions', 'company-permissions', () => import(`@/views/connections/manager/Permissions`)),
        Route('edit', 'company-edit', () => import(`@/views/connections/manager/Edit`)),
        Route('users', 'company-users', () => import(`@/views/connections/manager/Users`)),
      ]
    })
  )

})
